import { useEffect, useState } from 'react'

// Server and first client render always return false, the real value is read after mount.
export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        const media = window.matchMedia(query)
        const update = () => setMatches(media.matches)

        update()
        media.addEventListener('change', update)

        return () => media.removeEventListener('change', update)
    }, [query])

    return matches
}

export const usePrefersReducedMotion = (): boolean => useMediaQuery('(prefers-reduced-motion: reduce)')

export const useIsDesktop = (): boolean => useMediaQuery('(min-width: 1024px)')

export const useFinePointer = (): boolean => useMediaQuery('(hover: hover) and (pointer: fine)')
